// extracted by mini-css-extract-plugin
export var cartIcon = "_ni-0";
export var cartIconContainer = "_ni-1";